import myAxios from "../utils/request";
export default {
  commit(params) {
    return myAxios.post("/api/user/gettoken", params);
  },
  verificationCode(params) {
    return myAxios.get(`/api/user/getverificationcode?pageId=${params}`);
  }
};
